import { Box, Button, TextField } from "@mui/material";
import { useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../context/authContext";
import SectionHeader from "../../components/SectionHeader";
import {
  SignInBox1Sx,
  SignInBox2Sx,
  SignInButtonSx,
  TextFieldSx,
} from "./styles";
import toast from "react-hot-toast";
import authApi from "../../api/authApi";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();
  const { saveUser } = useAuthContext();

  const handleSubmit = useCallback(async () => {
    if (!email.trim() || !password.trim()) {
      toast.error("Please enter your email and password");
      return;
    }
    setIsSubmitting(true);
    try {
      const { data: { user, token } } = await authApi.post(`/auth/login`, { email, password });
      localStorage.setItem("authToken", `Bearer ${token}`);
      saveUser(user);
      navigate("/admin");
    } catch (error) {
      toast.error(error?.response?.data?.errorMessage || "Login failed");
    } finally {
      setIsSubmitting(false);
    }
  }, [email, navigate, password, saveUser]);

  const handleKeyDown = useCallback((e) => {
    if (e.key === "Enter") handleSubmit();
  }, [handleSubmit]);

  return (
    <Box sx={SignInBox1Sx}>
      <Box sx={SignInBox2Sx}>
        <SectionHeader title={"SIGN IN"} />

        <TextField
          label="E-mail"
          value={email}
          fullWidth
          sx={TextFieldSx}
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isSubmitting}
        />
        <TextField
          label="Password"
          type="password"
          value={password}
          fullWidth
          sx={TextFieldSx}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={isSubmitting}
        />
        <Button
          variant="outlined"
          sx={SignInButtonSx}
          onClick={handleSubmit}
          disabled={isSubmitting}
        >
          {isSubmitting ? "SIGNING IN..." : "SIGN IN"}
        </Button>
      </Box>
    </Box>
  );
};

export default SignIn;
